import React from 'react';
import { BedroomsCountRow } from '../../types';
import { useFilters } from '../../cube/filters';
import { D3BarChart } from './D3BarChart';

interface BedroomsBarProps {
  data: BedroomsCountRow[];
}

export const BedroomsBar: React.FC<BedroomsBarProps> = ({ data }) => {
  const { filters, set } = useFilters();
  const selected = filters.bedrooms || [];
  
  const clustered = React.useMemo(() => {
    const grouped = new Map<number, number>();
    (data || []).forEach((d) => {
      const bedrooms = d.bedrooms_bin;
      const key = bedrooms >= 7 ? 7 : bedrooms;
      grouped.set(key, (grouped.get(key) || 0) + (Number(d.count) || 0));
    });
    return Array.from(grouped.entries()).map(([key, value]) => ({ key, value }));
  }, [data]);

  return (
    <D3BarChart
      data={clustered}
      title="Imóveis por Quartos"
      xLabel="Quartos"
      yLabel="Número de Imóveis"
      selectedKeys={selected}
      onBarClick={(key) => {
        const k = Number(key);
        const active = selected.includes(k);
        const next = active ? selected.filter((n) => n !== k) : [...selected, k];
        set({ bedrooms: next.length ? next : undefined });
      }}
      formatXTick={(k) => Number(k) >= 7 ? '7+' : String(k)}
      formatYTick={(n) => String(Math.round(n))}
    />
  );
};


